var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRatingStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8398 3.66158L12.4639 7.10375C12.546 7.2772 12.7044 7.39746 12.8876 7.42555L16.5214 7.97904C16.7326 8.01237 16.9075 8.168 16.9728 8.38069C17.0381 8.59338 16.9824 8.82637 16.8291 8.98198L14.1987 11.6636C14.0661 11.7986 14.0058 11.9933 14.0376 12.1839L14.6583 15.9725C14.6955 16.1944 14.6082 16.4191 14.4334 16.5509C14.2586 16.6827 14.0272 16.6984 13.8376 16.5914L10.5967 14.8097C10.4329 14.7197 10.2372 14.7197 10.0735 14.8097L6.82438 16.5968C6.63474 16.7038 6.40328 16.6881 6.22851 16.5562C6.05373 16.4244 5.96639 16.1998 6.00364 15.9779L6.62432 12.1892C6.65611 11.9987 6.59583 11.804 6.46326 11.669L3.83691 8.9852C3.68364 8.82959 3.62798 8.5966 3.69325 8.38391C3.75852 8.17122 3.93344 8.01559 4.14468 7.98226L7.78259 7.42555C7.96576 7.39746 8.1241 7.2772 8.20629 7.10375L9.83032 3.66158C9.92533 3.46094 10.1209 3.33398 10.3351 3.33398C10.5492 3.33398 10.7448 3.46094 10.8398 3.66158Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatingStar);
export default __webpack_public_path__ + "static/media/rating-star.97250e5890e1f2485378f05e9dc88e97.svg";
export { ForwardRef as ReactComponent };